import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-259253f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['vstack', 'left'])
}


import Switch from './Switch.vue'

interface IProps {
  checked: boolean
  title: string
  subtitle?: string
  titleClassName?: string
  subtitleClassName?: string
  disabled?: boolean
}
interface IEmits {
  (e: 'change', isCheck: boolean): void | Promise<void>
}

export default /*#__PURE__*/_defineComponent({
  props: {
    checked: { type: Boolean },
    title: null,
    subtitle: null,
    titleClassName: null,
    subtitleClassName: null,
    disabled: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', isCheck: boolean): void | Promise<void>
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  checked: boolean
  title: string
  subtitle?: string
  titleClassName?: string
  subtitleClassName?: string
  disabled?: boolean
}





const onToggle = () => {
  const { disabled = false, checked } = props
  if (disabled) return
  console.log('点击了切换按钮:', !checked)
  emit('change', !checked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['hezi__switchbox', { 'is-disabled': __props.disabled }]),
    onClick: _withModifiers(onToggle, ["stop"])
  }, [
    _renderSlot(_ctx.$slots, "prefix"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: _normalizeClass(['title', { disabledTitle: !!__props.disabled }, __props.titleClassName])
      }, _toDisplayString(__props.title), 3),
      (__props.subtitle)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass([
          'subtitle',
          { disabledSubtitle: !!__props.disabled },
          __props.subtitleClassName,
        ])
          }, _toDisplayString(__props.subtitle), 3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Switch, {
      value: __props.checked,
      disabled: __props.disabled
    }, null, 8, ["value", "disabled"])
  ], 10, _hoisted_1))
}
}

})